import { Component, OnDestroy, OnInit, Output, EventEmitter, Input, ViewChild, NgZone } from '@angular/core';
import { Events } from '../../helpers/events';

// ionic
import { ModalController } from '@ionic/angular';

// ionic native
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { ImagePicker } from "@awesome-cordova-plugins/image-picker/ngx";
import { FileTransfer, FileTransferObject } from "@awesome-cordova-plugins/file-transfer/ngx";


import { DropzoneComponent, DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { DropzoneService } from "../../services/dropzone.service";
import { Helper } from "../../services/helper";

// other libraries
import { TranslateService } from "@ngx-translate/core";

// rxjs
import { Subject } from "rxjs";

// components
import { KeywordSelectComponent } from "../keyword-select/keyword-select.component";

// providers
import { NewsfeedService } from "../../services/newsfeed.service";
import { OverlayService } from "../../services/overlay.service";
import { PlatformService } from "../../services/platform.service";
import { UserService } from "../../services/user.service";
import { RouterExtService } from 'src/app/services/router-ext.service';

// models
import { Newsfeed } from "../../models/newsfeed";
import { UploadImage } from "../../models/upload-image";
import { Event } from "../../models/event";
import { User } from "../../models/user";

// config not using...
import { environment } from "../../../environments/environment";
import { dropZoneSettings } from "../../settings/dropzone.settings";

// helpers
import { log } from '../../helpers/log';

@Component({
    selector: 'add-newsfeed',
    templateUrl: './add-newsfeed.component.html',
    styleUrls: ['./add-newsfeed.component.scss']
})
export class AddNewsfeedComponent implements OnInit, OnDestroy {

    /**
     * dropzone
     *
     * @type ViewChild
     */
    @ViewChild('dropzoneVideo') dropzoneVideo;

    /**
     * dropzone
     *
     * @type ViewChild
     */
    @ViewChild('dropzoneImage') dropzoneImage;

    /**
     * dropzone
     *
     * @type ViewChild
     */
    @ViewChild('dropzoneFile') dropzoneFile;

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    // /**
    //  * current event
    //  *
    //  * @type {User}
    //  */
    // public user: User;
    //
    // /**
    //  * selected language
    //  *
    //  * @type string
    //  */
    // public userLang: string;

    /**
     * show form in modal
     *
     * @type boolean
     */
    @Input() modal: boolean = false;

    /**
     * newsfeed
     *
     * @type {Newsfeed}
     */
    @Input() newsfeed: Newsfeed = new Newsfeed;

    /**
     * preffill content
     *
     * @type string
     */
    @Input() message: string;

    /**
     * preffill link
     *
     * @type string
     */
    @Input() link: string;

    /**
     * preffill image
     *
     * @type string
     */
    @Input() image_url: string;

    /**
     * newsfeed
     *
     * @type {Newsfeed}
     */
    private newsfeedOriginal: Newsfeed = new Newsfeed;


    /**
     * users is sharing credential, provide hint and extend validation
     *
     * @type {boolean}
     */
    @Input() credentialSharing: boolean = false;

    /**
     * validate state
     *
     * @type {boolean}
     */
    public validate: boolean = false;

    /**
     * Validation errors
     *
     * @type {object}
     */
    public validationErrors: object = {};

    /**
     * validation errors state
     *
     * @type {boolean}
     */
    public hasValidationErrors: boolean = false;

    @Output() onNewsfeedSended: EventEmitter<Newsfeed> = new EventEmitter();
    @Output() onCanceled: EventEmitter<Newsfeed> = new EventEmitter();

    @Input() event: Event;
    @Input() user: User;

    /**
     * is image upload active
     *
     * @type {boolean}
     */
    public sending: boolean = false;

    /**
     * show link input
     *
     * @type {boolean}
     */
    public linkInputVisible: boolean = false;

    /**
     * dropzone config
     *
     * @type {DropzoneConfigInterface}
     */
    public dropZoneConfig: DropzoneConfigInterface = dropZoneSettings;

    /**
     * dropzone config
     *
     * @type {DropzoneConfigInterface}
     */
    public dropZoneConfigExtended: DropzoneConfigInterface = dropZoneSettings;

    /**
     * dropzone config for video
     *
     * @type {DropzoneConfigInterface}
     */
    public dropZoneConfigVideo: DropzoneConfigInterface = dropZoneSettings;

    /**
      * upload state
      *
      * @type {boolean}
      */
    public uploading: boolean = false;

    /**
      * The selected images
      *
      * @type UploadImage
      */
    public image: UploadImage = new UploadImage;

    /**
      * The selected images
      *
      * @type UploadImage
      */
    public froalaImage: UploadImage = new UploadImage;

    /**
      * Amount of progress made during an upload
      *
      * @type number
      */
    public progress: number = 0;

    /**
      * Amount of bugger made during an upload
      *
      * @type number
      */
    public buffer: number = 0;

    /**
      * The transfer object
      *
      * @type TransferObject
      */
    public fileTransfer: FileTransferObject = this.transfer.create();

    @Input() displayBigTextarea: boolean = false;

    @Input() showKeywords: boolean = true;

    /**
      * submit state
      *
      * @type {boolean}
      */
    public submit: boolean = false;

    // handlers for events
    eventChangeHandler;

    /**
     * constructor
     *
     * @param TranslateService
     * @param Camera
     * @param ImagePicker
     * @param FileTransfer
     * @param NgZone
     * @param Events
     * @param PlatformService
     * @param OverlayService
     * @param NewsfeedService
     * @param DropzoneService
     * @param ModalController
     */
    constructor(
        private routerExtService: RouterExtService,
        public userService: UserService,
        public translate: TranslateService,
        public camera: Camera,
        public imagePicker: ImagePicker,
        public transfer: FileTransfer,
        public ngZone: NgZone,
        public appEvents: Events,
        public plt: PlatformService,
        public overlayService: OverlayService,
        public newsfeedService: NewsfeedService,
        public dropzoneService: DropzoneService,
        public modalController: ModalController
    ) {
        // dropzone config
        this.dropZoneConfig = { ...dropzoneService.dropzoneConfig };
        this.dropZoneConfig.maxFilesize = 4;
        this.dropZoneConfig.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif';
        this.dropZoneConfig.autoReset = 1000;
        this.dropZoneConfig.dictDefaultMessage = null;

        // dropzone extended config
        this.dropZoneConfigExtended = { ...dropzoneService.dropzoneConfig };
        this.dropZoneConfigExtended.maxFilesize = 10;
        this.dropZoneConfigExtended.acceptedFiles = 'application/pdf';
        this.dropZoneConfigExtended.autoReset = 1000;

        // dropzone extended config
        this.dropZoneConfigVideo = { ...dropzoneService.dropzoneConfig };
        this.dropZoneConfigVideo.maxFilesize = 500;
        this.dropZoneConfigVideo.acceptedFiles = 'video/mp4,video/quicktime,video/x-ms-wmv,video/x-msvideo';
        this.dropZoneConfigVideo.autoReset = 1000;
    }

    /**
     * on init
     *
     * @return void
     */
    ngOnInit() {
        this.dropZoneConfig.url = environment.api + '/newsfeed/upload?ngsw-bypass=true';
        this.dropZoneConfigExtended.url = environment.api + '/newsfeed/upload?ngsw-bypass=true';
        this.dropZoneConfigVideo.url = environment.api + '/newsfeed/upload?ngsw-bypass=true';
        this.newsfeedOriginal = new Newsfeed(this.newsfeed);

        this.eventChangeHandler = () => {
            this.newsfeed = new Newsfeed;
        }

        // attach hooks on event change
        this.appEvents.subscribe('event:changed', this.eventChangeHandler);

        if (!this.newsfeed.id) {
            if (this.message) {
                this.newsfeed.message = this.message;
            }

            if (this.link) {
                this.newsfeed.link = this.link;
            }

            if (this.image_url) {
                this.newsfeed.image = this.image_url;
                this.newsfeed.image_url = this.image_url;
            }
        }

        if (this.credentialSharing) {
            this.newsfeed.shareCredential = true;
            this.newsfeed.link_name = this.translate.instant('CREDENTIAL_SHARE_LINK_NAME');
        }
    }

    public editNewsfeed(newsfeed: Newsfeed) {
        this.newsfeed = newsfeed;
        this.newsfeedOriginal = new Newsfeed(this.newsfeed);
    }

    /**
     * send new newsfeed
     */
    public postNewsfeed(valid) { 
        if (valid) {
            this.validationErrors = {};
            this.validate = true;
            this.newsfeed.event_id = this.event.id;
            this.submit = true;

            // update
            if (this.newsfeed.id) {
                this.newsfeedService.update(this.newsfeed).subscribe(
                    (success) => {
                        this.handleSuccess(success);
                    },
                    (error) => {
                        this.handleError(error);
                    }
                );
            }
            // create
            else {
                this.newsfeedService.create(this.newsfeed).subscribe(
                    (success) => {
                        this.handleSuccess(success, true);
                    },
                    (error) => {
                        this.handleError(error);
                    }
                );
            }
        }
    }

    private handleSuccess(response, reset: boolean = false) {
        this.overlayService.showSuccess(response.message);
        this.newsfeed = response.newsfeed && !reset ? new Newsfeed(response.newsfeed) : new Newsfeed;
        this.onNewsfeedSended.emit(this.newsfeed);
        this.validate = false;
        this.displayBigTextarea = false;
        if (this.modal) {
            // close modal if used..
            this.closeSaved();
        }
        this.submit = false;
    }

    private handleError(response) {
        const data = response.error;

        if (data.fields) {
            for (const field in data.fields) {
                if (data.fields.hasOwnProperty(field)) {
                    this.hasValidationErrors = true;
                    this.validationErrors[field] = data.fields[field].join(' ');
                }
            }
        }

        this.submit = false;
        this.overlayService.showError(data.message);
    }

    /**
     * on image upload
     *
     * @param args
     */
    public onSending(args: any, file: boolean = false, uploadProgress: boolean = false) {
        this.sending = true;
        if (uploadProgress) {
            this.uploading = true;
        }

        let dropzone = file ? this.dropzoneFile : this.dropzoneImage;

        const xhrRequest = args[1];

        xhrRequest.ontimeout = ((event) => {
            dropzone.directiveRef.dropzone().removeAllFiles(true); // remove not uploaded files
            this.overlayService.showError(this.translate.instant('REQUEST_TIMEOUT'));
        });

        xhrRequest.withCredentials = true;
        xhrRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }

    /**
     * on upload progress
     *
     * @param args
     */
    public uploadProgress(event) {
        this.progress = event[0] / 100;
        this.buffer = this.progress + 0.06;
    }

    /**
     * on upload finished
     *
     * @param args
     */
    public onUploadSuccess(args: any, type = 'image') {
        switch (type) {
            case 'file':
                this.newsfeed.file = args[1].file;
                this.newsfeed.file_url = args[1].file_url;
                this.newsfeed.filename = args[1].filename;
                this.sending = false;
                this.uploading = false;
                break;
            case 'video':
                this.newsfeed.video = args[1].file;
                this.newsfeed.video_url = args[1].file_url;
                // check video upload on background periodically
                this.uploading = false;
                this.checkVideoUpload(args[1].video_upload_id);
                break;
            default:
                this.newsfeed.image = args[1].file;
                this.newsfeed.image_url = args[1].file_url;
                this.sending = false;
                this.uploading = false;
        }
    }

    /**
     * on error during upload
     *
     * @param args
     */
    public onUploadError(args: any, type: string = 'image') {

        const message = args[1];

        // show customized errors for upload limits coming from server side
        if (typeof message !== 'string') {
            if (message.hasOwnProperty('message')) {
                this.overlayService.showError(message.message);
            } else {
                this.overlayService.showError(this.translate.instant('VALIDATION_IMAGE_OTHER'));
            }
        } else {
            if (message.indexOf('too large') !== -1 || message.indexOf('est trop grande') !== -1 || message.indexOf('ist zu gro') !== -1) {

                let maxSize = this.dropZoneConfig.maxFilesize;
                switch (type) {
                    case 'video':
                        maxSize = this.dropZoneConfigVideo.maxFilesize;
                        break;
                    case 'file':
                        maxSize = this.dropZoneConfigExtended.maxFilesize;
                        break;
                }

                this.overlayService.showError(this.translate.instant('VALIDATION_IMAGE_TOO_LARGE', {
                    maxSize: maxSize
                }));

                this.deleteImage();

            } else if (message.toLowerCase().indexOf('upload files of this type') !== -1) {

                let fileTypes = this.dropZoneConfig.acceptedFiles;
                switch (type) {
                    case 'video':
                        fileTypes = this.dropZoneConfigVideo.acceptedFiles;
                        break;
                    case 'file':
                        fileTypes = this.dropZoneConfigExtended.acceptedFiles;
                        break;
                }

                this.overlayService.showError(this.translate.instant('VALIDATION_WRONG_TYPE', {
                    fileTypes: fileTypes.split(',').join(', ')
                }));

            } else {
                // NOTE[jg]  maybe some general error?
                this.overlayService.showError(this.translate.instant('VALIDATION_IMAGE_OTHER'));
            }
        }
        this.uploading = false;
        this.sending = false;
    }

    /**
     * destroy image
     *
     * @return void
     */
    public checkVideoUpload(id: string, iteration: number = 0) {
        this.userService.checkVideoUpload(id).subscribe(
            (videoUpload) => {
                if (videoUpload.status == 'uploaded') {
                    this.sending = false;
                    this.newsfeed.video = videoUpload.uploaded_id;
                    this.newsfeed.display_video = true;
                    this.newsfeed.video_embed_link = 'https://player.vimeo.com/video/' + videoUpload.uploaded_id.replace('/videos/', '');
                } else {
                    // wait 2min to check upload status
                    if (iteration < 13) {
                        // check again after some time
                        setTimeout(() => {
                            this.checkVideoUpload(id, iteration++);
                        }, 10000)
                    } else {
                        this.sending = false;
                        // trigger some error
                        this.overlayService.showError(this.translate.instant('VIDEO_UPLOAD_PROCESSING_FAILED'));
                    }
                }
            }
        )
    }

    /**
     * destroy image
     *
     * @return void
     */
    public deleteImage() {
        this.newsfeed.image = null;
        this.newsfeed.image_url = null;

        // call endpoint to remove image...

        this.sending = false;
        // TODO
        if (!this.plt.is('cordova')) {
            this.dropzoneImage.directiveRef.reset();
        }
    }

    /**
     * destroy file
     *
     * @return void
     */
    public deleteFile() {
        this.newsfeed.file = null;
        this.newsfeed.file_url = null;
        this.newsfeed.filename = null;

        // call endpoint to remove file...

        this.sending = false;
        // TODO
        if (!this.plt.is('cordova')) {
            this.dropzoneFile.directiveRef.reset();
        }
    }

    /**
     * destroy video
     *
     * @return void
     */
    public deleteVideo() {
        this.newsfeed.video = null;
        this.newsfeed.video_url = null;
        this.newsfeed.display_video = false;

        // call endpoint to remove file from S3 + video provider

        this.sending = false;
        // TODO
        if (!this.plt.is('cordova')) {
            this.dropzoneFile.directiveRef.reset();
        }
    }

    /**
      * open gallery
      *
      * @return {Promise<void>}
      */
    public async openAlbums(file = false): Promise<void> {
        this.plt.reloadable = false;

        if (await this.imagePicker.hasReadPermission()) {

            try {
                let originals = await this.fileManager();
                if (originals.length) {
                    let requests = await originals.map(async x => new UploadImage({
                        path: x,
                        guid: Helper.guid(),
                        thumb: x // eventually resize before upload via "await this.resize(x)"
                    }));

                    let images = await Promise.all(requests);
                    this.image = images[0];

                    setTimeout(() => {
                        this.uploadImage(file);
                    }, 0);
                } else {
                    this.plt.reloadable = true;
                }
            } catch (exception) {
                this.plt.reloadable = true;
            }

        } else {

            let interval = setInterval(() => {
                this.imagePicker.hasReadPermission().then((boolHasPermissions) => {
                    if (boolHasPermissions) {
                        clearInterval(interval);
                        this.openAlbums(file);
                    }
                });
            }, 1000);

            if (this.plt.is('ios')) {
                this.imagePicker.requestReadPermission();
            }

            if (this.plt.is('android')) {
                this.imagePicker.requestReadPermission();
            }

        }
    }

    /**
     * Opens the albums
     *
     * @return A collection of urls from the selected images
     */
    public fileManager(): Promise<Array<string>> {
        return this.imagePicker.getPictures({
            quality: 90,
            width: 2880,
            // height: 900,
            maximumImagesCount: 1,
        });
    }

    /**
     * Actually uploads an image
     */
    public async uploadImage(file = false): Promise<void> {
        // if (file) {
        //     detail.uploading = true;
        // } else {
        //     this.uploading = true;
        // }
        this.uploading = true;

        this.plt.keepAwake();

        // Bind the progress function
        this.fileTransfer.onProgress(this.onProgress);

        let token = localStorage.getItem('token');

        // Prepare our upload options
        let options = {
            fileKey: 'file',
            fileName: this.image.path.split('/').pop(),
            mimeType: 'image/jpeg',
            chunkedMode: false,
            file: file,
            headers: {
                'Authorization': 'Bearer ' + token,
                // set proper origin to receive same assets URL for resource
                'Origin': environment.assets
            },
            params: {}
        };

        try {
            let result = await this.fileTransfer.upload(
                encodeURI(this.image.path),
                encodeURI(environment.api + '/newsfeed/upload?ngsw-bypass=true'),
                options,
                false
            );

            if (file) {
                // set upload file
                this.newsfeed.file = JSON.parse(result.response).file;
                this.newsfeed.file_url = JSON.parse(result.response).file_url;
                this.newsfeed.filename = JSON.parse(result.response).filename;
            } else {
                // set upload paths to participant
                this.newsfeed.image = JSON.parse(result.response).file;
                this.newsfeed.image_url = JSON.parse(result.response).file_url;
            }

            if (result.response) {
                this.plt.reloadable = true;
                // if (file) {
                //     detail.uploading = false;
                // } else {
                //     this.uploading = false;
                // }
                this.uploading = false;
                this.plt.allowSleepAgain();
                //this.showSuccess(this.translate.instant('MESSAGE_UPLOAD_SUCCESS'));
            }
        }
        catch (e) {
            log('error', 'openAlbums', e);
            this.overlayService.showError();
            this.plt.reloadable = true;
            // if (file) {
            //     detail.uploading = false;
            // } else {
            //     this.uploading = false;
            // }
            this.uploading = false;
            this.plt.allowSleepAgain();
        }
    }

    /**
     * Opens the camera and display the taken picture if available
     */
    public async openCamera(file = false): Promise<void> {
        this.plt.reloadable = false;

        try {
            let image = await this.cameraManager();

            if (image) {
                this.image = new UploadImage({
                    path: image,
                    guid: Helper.guid(),
                    thumb: image // eventually resize before upload via "await this.resize(x)"
                });

                setTimeout(() => {
                    this.uploadImage(file);
                }, 0);
            } else {
                this.plt.reloadable = true;
            }
        } catch (exception) {
            this.plt.reloadable = true;
        }
    }

    /**
     * Opens the camera so that the user can take a picture
     *
     * @return The url of the taken image
     */
    private cameraManager(): Promise<string> {
        return this.camera.getPicture({
            // We want to have the URL to the file
            destinationType: this.camera.DestinationType ? this.camera.DestinationType.FILE_URI : 1,
            // Source of the images is the camera
            sourceType: this.camera.PictureSourceType ? this.camera.PictureSourceType.CAMERA : 1,
            // Encoding type is JPEG
            encodingType: this.camera.EncodingType ? this.camera.EncodingType.JPEG : 0,
            // Give us the full quality of the image, lower it for better performance
            quality: 90,
            // Allow editing of the image after its taken
            allowEdit: false,
            // When a image is taken via the camera also save it to the native photo album
            saveToPhotoAlbum: false,
            // Correct the orrientation of the image
            correctOrientation: true,
            // Resize to save bandwidth and prevent rejection by the server
            targetWidth: 2880,
            // targetHeight: 1800
        });
    }

    /**
     * The on upload progress callback event
     *
     * @param progressEvent The progress event of the image upload
     */
    public onProgress = (progressEvent: ProgressEvent, file?): void => {
        this.ngZone.run(() => {
            if (progressEvent.lengthComputable) {
                let progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                if (progress > 100) progress = 100;
                if (progress < 0) progress = 0;
                // if (detail) {
                //     detail.progress = progress;
                // } else {
                //     this.progress = progress;
                // }
                this.progress = progress;
            }
        });
    };

    public showLinkInput() {
        this.linkInputVisible = true;
    }

    /**
     * open keyword select modal
     *
     * @return void
     */
    public async showKeywordsModal() {

        this.routerExtService.softNavigate();

        const modal = await this.modalController.create({
            component: KeywordSelectComponent,
            cssClass: 'keyword-select-modal',
            componentProps: {
                pivots: [...this.newsfeed.keywords]
            }
        });

        modal.onWillDismiss().then((data) => {

            if (data.data?.keywords) {
                this.newsfeed.keywords = [...data.data.keywords];
                this.newsfeed.initKeywordsUnique();
            }

            if (data.data?.action == 'close' || data.role == 'backdrop') {
                this.routerExtService.softBack();
            }

        });

        return await modal.present();
    }

    /**
     * close modal window
     *
     */
    public backClicked(modal = true) {
        if (modal) {
            this.modalController.dismiss({ action: 'close', newsfeed: this.newsfeedOriginal });
        } else {
            this.onCanceled.emit(this.newsfeedOriginal);
        }
    }

    /**
     * close modal window
     *
     */
    public closeSaved() {
        this.modalController.dismiss({ action: 'close', newsfeed: this.newsfeed });
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        if (this.eventChangeHandler) {
            this.appEvents.unsubscribe('event:changed', this.eventChangeHandler);
        }
        // this.overlayService.closeModals();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

}
